module.exports = __webpack_public_path__ + "bg.f31daef0f7c6799d174a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg.jpg
// module id = 1033
// module chunks = 2